export default "__VITE_PUBLIC_ASSET__9c3a35c0__"